import { BusinessEntityModel } from "./business-entity.model";

export class StoreModel extends BusinessEntityModel  {
  group: string
  constructor(obj: any = null) {
    super(obj)
    this.group = obj?.group
  }
}


